export const PAID_ACCESS_REASON = "paid_credit_or_subscription_required";
export const INSUFFICIENT_CREDIT_REASON = "insufficient_credit";

export function isTopicSelectable(topic) {
  // Missing is_selectable preserves the older backend's selection behaviour.
  return topic?.is_selectable !== false;
}

export function getTopicId(topic) {
  return topic?.topic_id || topic?.question_set_id || "";
}

export function getFirstSelectableTopicId(topics = []) {
  return getTopicId(topics.find(isTopicSelectable));
}

export function getTopicOptionLabel(topic) {
  const title = topic?.topic_title || topic?.question_set_name || "";
  if (!isTopicSelectable(topic)) {
    return `${title} — Paid Access`;
  }
  if (topic?.access_badge === "Free trial") {
    return `${title} — Free Trial`;
  }
  return title;
}

export function hasTopicAccessMetadata(topics = []) {
  return topics.some((topic) =>
    ["access_tier", "is_selectable", "access_badge", "lock_reason"].some((key) =>
      Object.prototype.hasOwnProperty.call(topic || {}, key)
    )
  );
}

export function getOralAccessNotice(details = {}) {
  const reason =
    details?.reason || details?.error_reason || details?.error_code || details?.code || "";
  const backendMessage = details?.lock_message || details?.message || "";

  // Stable backend reasons choose the UI state; supplied messages remain authoritative.
  if (reason === PAID_ACCESS_REASON) {
    return {
      reason,
      title: "Paid Access Required",
      message:
        backendMessage ||
        "This topic requires paid credits or an active subscription. Your promotional credits can be used on topics marked Free trial.",
      canChooseFreeTrial: true,
    };
  }

  if (reason === INSUFFICIENT_CREDIT_REASON) {
    return {
      reason,
      title: "Oral Practice Access Needed",
      message:
        backendMessage ||
        "You do not have enough credits to start this oral practice.",
      canChooseFreeTrial: false,
    };
  }

  return null;
}

export function getTopicLockMessage(topic) {
  if (topic?.lock_message) {
    return topic.lock_message;
  }
  if (topic?.lock_reason === PAID_ACCESS_REASON) {
    return "This topic requires paid credits or an active subscription.";
  }
  if (topic?.lock_reason === INSUFFICIENT_CREDIT_REASON) {
    return "You do not have enough credits to start this oral practice.";
  }
  return "This topic is currently locked.";
}
